'use strict';

var _createClass = require("/home/runner/work/itau-jn6-app-reneg-www/itau-jn6-app-reneg-www/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/home/runner/work/itau-jn6-app-reneg-www/itau-jn6-app-reneg-www/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _possibleConstructorReturn = require("/home/runner/work/itau-jn6-app-reneg-www/itau-jn6-app-reneg-www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/runner/work/itau-jn6-app-reneg-www/itau-jn6-app-reneg-www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _inherits = require("/home/runner/work/itau-jn6-app-reneg-www/itau-jn6-app-reneg-www/node_modules/@babel/runtime/helpers/inherits.js");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Node = require('./node');
var Comment = /*#__PURE__*/function (_Node) {
  _inherits(Comment, _Node);
  function Comment(defaults) {
    var _this;
    _classCallCheck(this, Comment);
    _this = _callSuper(this, Comment, [defaults]);
    _this.type = 'comment';
    return _this;
  }
  return _createClass(Comment);
}(Node);
module.exports = Comment;
Comment.default = Comment;